// extracted by mini-css-extract-plugin
export default {"container":"Tz-z","dimension":"Uz-z","dimensionLabels":"Vz-z"};